/* Dawn's desktop drawer sort form omits the actual filters, which live in
   FacetFiltersFormMobile. Submit through that existing form so sorting keeps
   its checked values, price range and search query in one native update. */
(() => {
  const boundKey = Symbol.for('better-deals.drawer-sort-bridge');
  if (document[boundKey]) return;
  document[boundKey] = true;

  document.addEventListener('input', event => {
    const desktopSort = event.target;
    if (!desktopSort?.matches?.('#FacetSortDrawerForm select[name="sort_by"]')) return;
    const container = desktopSort.closest('.facets-container-drawer');
    const drawerForm = container?.querySelector('#FacetFiltersFormMobile');
    const drawerSort = drawerForm?.querySelector('select[name="sort_by"]');
    const nativeController = drawerForm?.closest('facet-filters-form');
    if (!drawerSort || typeof nativeController?.onSubmitHandler !== 'function') return;
    if (!Array.from(drawerSort.options).some(option => option.value === desktopSort.value)) return;

    drawerSort.value = desktopSort.value;
    // Capture stops the incomplete desktop form's debounced listener. The
    // mirrored input reaches Dawn's existing listener and analytics path once.
    event.stopPropagation();
    drawerSort.dispatchEvent(new Event('input', { bubbles: true }));
  }, true);
})();
